import { useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import pick from 'lodash/pick';
import { PRISTINE, PENDING } from 'utils/constants/queryStatuses';
import { useAuth } from 'utils/hooks/useAuth';
import { useLocationSearchParameters } from 'utils/hooks/useLocationSearchParameters';
import { REMATCH_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { useUpdateLocationSearchParameters } from 'utils/hooks/useUpdateLocationSearchParameters';
import { matchesActions } from './actions';

export const useMatchesFetching = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const replaceLocationSearchParameters = useUpdateLocationSearchParameters({ isPushMethod: false });
  const {
    matches: { status: matchesStatus },
  } = useSelector((state) => pick(state, ['matches', 'profile', 'main']));
  const {
    [REMATCH_URL_SEARCH_PARAM]: rematchSearchParam,
    update: updateSearchParam,
    newest: newestSearchParam,
  } = useLocationSearchParameters();

  const shouldFetch = !!(
    isAuthenticated && matchesStatus !== PENDING
    && (matchesStatus === PRISTINE || rematchSearchParam || updateSearchParam)
  );

  useEffect(() => {
    if (!shouldFetch) {
      return;
    }

    batch(() => {
      // Note:
      // - calling MatchFlow.setMatchFlow() don't trigger fetching
      // - having MatchFlow.getMatchFlow() === MATCH_FLOWS.BASIC does not guarantee rematch
      // - is update url search parameter used?

      dispatch(matchesActions.requestMatches({
        forceRematch: !!rematchSearchParam,
        requestToRematch: !!updateSearchParam,
        newest: newestSearchParam ?? null,
      }));

      replaceLocationSearchParameters({
        [REMATCH_URL_SEARCH_PARAM]: null,
        update: null,
      });
    });
  }, [dispatch, newestSearchParam, rematchSearchParam, replaceLocationSearchParameters, shouldFetch, updateSearchParam]);
};
